import React from 'react'
import { CreditApplication } from '_gql'

import { FormattedMessage } from '@divvy-web/i18n'

import ImageWrapper from '@sputnik/components/ImageWrapper'
import StatusButtons from '@sputnik/components/StatusButtons'
import useGoToOffers from '@sputnik/hooks/useGoToOffers'
import StatusTile from '@sputnik/pages/Dashboard/StatusTile/StatusTile'

interface ReviewOfferStatusTileProps {
  creditApp: CreditApplication
}

const ReviewOfferStatusTile = ({ creditApp }: ReviewOfferStatusTileProps) => {
  const { salesforceCreditId, statusUpdatedAt, authorizedSigner } = creditApp || {}
  const { decisions, handleGoToOffers, isLoggedInUserAuthorizedSigner } = useGoToOffers({
    salesforceCreditId,
    authSignerEmail: authorizedSigner?.email as string,
  })
  const hasSelectedDecision = !!decisions?.find((decision) => decision.userSelectedAt)
  const showGoToOfferButton = decisions?.length > 0 && !hasSelectedDecision

  const primaryInfoMessage = () => {
    if (isLoggedInUserAuthorizedSigner && showGoToOfferButton) {
      return (
        <FormattedMessage
          defaultMessage='Check your credit offers for more details.'
          id='sputnik.ReviewOfferStatusTile__49A6he'
        />
      )
    }
    if (isLoggedInUserAuthorizedSigner && !showGoToOfferButton) {
      return (
        <FormattedMessage
          defaultMessage='Refresh browser or check back shortly to view offers.'
          id='sputnik.ReviewOfferStatusTile__eUF+ke'
        />
      )
    }
    if (!isLoggedInUserAuthorizedSigner) {
      return (
        <FormattedMessage
          defaultMessage='Only the authorized signer ({email}) can accept this offer.'
          id='sputnik.ReviewOfferStatusTile__TdYnmo'
          values={{
            email: authorizedSigner?.email || '',
          }}
        />
      )
    }
  }

  return (
    <StatusTile
      creditApp={creditApp}
      image={
        <ImageWrapper
          alt='person with party hat with hands in the air'
          imageName='dashboard-application-approved-status'
        />
      }
      primaryInfo={primaryInfoMessage()}
      secondaryInfo={
        <FormattedMessage
          defaultMessage='Approved on {date, date, long}'
          id='sputnik.ReviewOfferStatusTile__3WYvB+'
          values={{ date: new Date(statusUpdatedAt) }}
        />
      }
      title={
        <FormattedMessage
          defaultMessage="You've been approved for a line of credit!"
          id='sputnik.ReviewOfferStatusTile__LyMph6'
        />
      }
    >
      <StatusButtons
        hideSecondary
        hidePrimary={!showGoToOfferButton || !isLoggedInUserAuthorizedSigner}
        primaryText={
          <FormattedMessage
            defaultMessage='Go to {offers, plural, one {offer} other {offers}}'
            id='sputnik.ReviewOfferStatusTile__flDVZF'
            values={{ offers: decisions?.length }}
          />
        }
        onPrimaryClick={handleGoToOffers}
      />
    </StatusTile>
  )
}

export default ReviewOfferStatusTile
